import classNames from 'classnames'
import { FunctionComponent, ReactNode } from 'react'
import { Swiper, SwiperProps, SwiperSlide } from 'swiper/react'
import { Mousewheel } from 'swiper/modules'
import 'swiper/scss'
import 'swiper/scss/mousewheel'
import './BaseCarousel.scss'
import { generateId } from './BaseCarousel.utils'

interface BaseCarouselProps {
  items: ReactNode[]
  swiperProps?: SwiperProps
  className?: string
  enableMousewheel?: boolean
}

const defaultSettings: SwiperProps = {
  spaceBetween: 16,
  navigation: false
}

export const BaseCarousel: FunctionComponent<BaseCarouselProps> = ({
  items,
  swiperProps,
  className,
  enableMousewheel = false
}) => {
  const swiperSettings: SwiperProps = {
    ...defaultSettings,
    ...(swiperProps ?? {})
  }

  // Add mousewheel support if enabled
  if (enableMousewheel) {
    swiperSettings.mousewheel = {
      enabled: true,
      sensitivity: 1,
      releaseOnEdges: true
    }
    swiperSettings.modules = [Mousewheel, ...(swiperSettings.modules ?? [])]
  }

  return (
    <div
      className={classNames('core-ux-base-carousel', className)}
      data-testid="base-carousel">
      <Swiper
        className="core-ux-base-carousel__container"
        slidesPerView="auto"
        {...swiperSettings}>
        {items.map((item, index) => (
          <SwiperSlide
            key={generateId(index)}
            className="core-ux-base-carousel__slide">
            {item}
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  )
}
